<template>
  <div id="pdfDom" class="qrCode">
    <el-dialog
        :visible.sync="dialogVisible"
        :modal="false"
        title="打印"
        width="1300px"
        top="10vh">
      <div id="content">
        <div style="margin-bottom: 15px" class="qrCode-div">
          <table
              cellpadding="0"
              cellspacing="0"
              border="1"
              style="width: 100%"
              class="table">
            <tr>
              <!--							<td style="text-align: center"><img src="../../../public/img/steplogo.png" style="width: 100px" /></td>-->
              <td colspan="6" style="text-align: center;font-size: 20px">售后服务材料单</td>
              <td colspan="2">
                <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center">
                  <div style="display: flex;flex-direction: row;align-items: center;width: 50%">
                    <div style="padding: 0 10px">版本 :</div>
                    <div>D</div>
                  </div>
                  <div style="display: flex;flex-direction: row;align-items: center;width: 50%">
                    <div style="padding: 0 10px">修订 :</div>
                    <div>0</div>
                  </div>
                </div>
                <div style="display: flex;flex-direction: row;align-items: center">
                  <div style="padding: 0 10px">编号 :</div>
                  <div>No.1</div>
                </div>
              </td>
            </tr>
            <tr>
              <td style="text-align: center;width: 120px">售后单号</td>
              <td style="text-align: center" colspan="3">
                <div style="font-size: 15px">{{model.billNo}}</div>
              </td>
              <td style="text-align: center;width: 120px">客户单号</td>
              <td style="text-align: center">{{model.customerBillNo}}</td>
              <td style="text-align: center;width: 120px">项目号</td>
              <td style="text-align: center">{{model.faultSerialNO}}</td>
            </tr>
            <tr>
              <td style="text-align: center;width: 120px">客户名称</td>
              <td style="text-align: center" colspan="3">
                <div style="font-size: 15px">{{model.customerName}}</div>
              </td>
              <td style="text-align: center;width: 120px">销售员</td>
              <td style="text-align: center">{{model.salesMan}}</td>
              <td style="text-align: center;width: 120px">项目名称</td>
              <td style="text-align: center">{{model.siteName}}</td>
            </tr>
            <tr>
              <td style="text-align: center;width: 120px">现场人员</td>
              <td style="text-align: center" colspan="3">
                <div style="font-size: 15px">{{model.contact}}</div>
              </td>
              <td style="text-align: center;width: 120px">联系方式-现场</td>
              <td style="text-align: center">{{model.mobile}}</td>
              <td style="text-align: center;width: 120px">出厂编号</td>
              <td style="text-align: center">{{model.salesOrderNo}}</td>
            </tr>
            <tr>
              <td style="text-align: center;width: 120px">收货人</td>
              <td style="text-align: center" colspan="3">
                <div style="font-size: 15px">{{model.consignee}}</div>
              </td>
              <td style="text-align: center;width: 120px">联系方式-收货</td>
              <td style="text-align: center">{{model.consigneeMobile}}</td>
              <td style="text-align: center;width: 120px">收货地址</td>
              <td style="text-align: center">{{model.deliveryAddress}}</td>
            </tr>
            <tr>
              <td style="text-align: center;width: 120px">运费是否到付</td>
              <td style="text-align: center">{{model.deliveryPaymentType ? "是" : "否"}}</td>
              <td style="text-align: center;width: 120px">快递方式</td>
              <td style="text-align: center">{{model.deliveryType}}</td>
              <td style="text-align: center;width: 120px">是否已技术支持</td>
              <td style="text-align: center">{{model.isTechnicalSupport ? "是" : "否"}}</td>
              <td style="text-align: center;width: 120px">是否已质量核实</td>
              <td style="text-align: center">{{model.isSurvey ? "是" : "否"}}</td>
            </tr>
            <tr>
              <td style="text-align: center;width: 120px">是否过质保</td>
              <td style="text-align: center">{{model.underWarranty ? "是" : "否"}}</td>
              <td style="text-align: center;width: 120px">现场环境</td>
              <td style="text-align: center">{{model.environment}}</td>
              <td style="text-align: center;width: 120px">故障发生阶段</td>
              <td style="text-align: center">{{constant.stage[model.stage]}}</td>
              <td style="text-align: center;width: 120px">登记时间</td>
              <td style="text-align: center">{{model.createTime}}</td>
            </tr>
            <tr>
              <td style="text-align: center;width: 120px">登记人</td>
              <td style="text-align: center">{{model.creatorName}}</td>
            </tr>
            <tr>
              <td colspan="8" style="height: 20px;"/>
            </tr>

            <tr>
              <td colspan="8" style="padding: 0">
                <table cellpadding="0" cellspacing="0" style="width: 100%">
                  <tr v-for="(item2, index) in handleDetailVos" :key="index">
                    <td colspan="8" style="padding: 10px;border-bottom: 1px solid #000">
                      <div>{{item2.nodeText}}：</div>
                      <div v-if="item2.handleRemark">{{item2.handleRemark}}</div>
                      <div v-else>{{item2.handleResultText}}</div>
                      <div style="text-align: right">
                        <span>审核时间：{{item2.handleTime}}</span>
                        <span style="margin-left: 20px">审核人：{{item2.handlerName}}</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td colspan="8" style="padding: 10px">
                <div>备注：</div>
                <div style="text-indent: 27px">
                  {{model.note}}
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="8" style="padding: 0">
                <table cellpadding="0" cellspacing="0" style="width: 100%">
                  <tr>
                    <td style="text-align: center;border-right: 1px solid #000;width:90px;">物料号</td>
                    <td style="text-align: center;border-right: 1px solid #000;width:200px" colspan="2">物料名称</td>
                    <td style="text-align: center;border-right: 1px solid #000;">变频器/板卡条码</td>
                    <td style="text-align: center;border-right: 1px solid #000;">现程序号</td>
                    <td style="text-align: center;border-right: 1px solid #000;">产品分类</td>
                    <td style="text-align: center;border-right: 1px solid #000;">数量</td>
                    <td style="text-align: center;border-right: 1px solid #000;">单位</td>
                    <td style="text-align: center;border-right: 1px solid #000;">故障码</td>
                    <td style="text-align: center;border-right: 1px solid #000;">故障分类</td>
                    <td style="text-align: center;border-right: 1px solid #000;">是否新件</td>
                    <td style="text-align: center;border-right: 1px solid #000;">发运类型</td>
                    <td style="text-align: center;border-right: 1px solid #000;">发运人</td>
                    <td style="text-align: center;border-right: 1px solid #000;">发货时间</td>
                    <td style="text-align: center;border-right: 1px solid #000;">发货单号</td>
                    <td style="text-align: center;border-right: 1px solid #000;">退回单号</td>
                  </tr>
                  <tr v-for="(items, index) in model.details" :key="index">
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">
                      {{items.materialNo}}
                    </td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000" colspan="2">
                      {{items.materialDesc}}
                    </td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">
                      {{items.mainPartsSerialNo}}
                    </td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">
                      {{items.presentSoftware}}
                    </td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">
                      {{items.materialType}}
                    </td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">
                      {{items.quantity}}
                    </td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">
                      {{items.unit}}
                    </td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">
                      {{items.faultCode}}
                    </td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">
                      {{items.faultType}}
                    </td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">
                      <span v-if="items.isNewRequest === 0">否</span>
                      <span v-else-if="items.isNewRequest === 1">是</span>
                      <span v-else>可新可旧</span>
                    </td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">
                      {{items.deliveryType}}
                    </td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">
                      {{items.deliveryPerson}}
                    </td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">
                      {{items.deliveryDate}}
                    </td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">
                      {{items.deliveryBillNo}}
                    </td>
                    <td style="text-align: center;border-right: 1px solid #000;border-top:1px solid #000">
                      {{items.backNo}}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
        <el-button type="primary" plain @click="printCurrent">打印</el-button>
        <el-button plain type="success" @click="print">导出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import html2Canvas from "html2canvas";
  import JsPDF from "jspdf";
  import moment from "moment";
  import constant from "@/util/constant";

  export default {
    components: {},
    data() {
      return {
        constant,
        dialogVisible: false,
        contentLoading: false,
        pageData: null, //接收html格式代码
        htmlTitle: "",
        tableData: [],
        handleDetailVos: [],
        model: {
          deliveryDate: "",
        },
      };
    },
    methods: {
      open(vo) {
        this.ids = [];
        this.model = vo;
        console.log(vo);
        this.model.deliveryDate = moment().format("YYYY-MM-DD");
        this.dialogVisible = true;
        this.tableData = vo.details;
        this.getHandleDetailVos(vo.pkid);
      },
      getHandleDetailVos(id) {
        this.handleDetailVos = [];
        this.$http
          .get("basic", `applications/handle-detail/13/${id}`)
          .then(resp => {
            console.log(resp);
            let list = resp.handleDetailVos.reverse();
            for (let item of list) {
              if (!item.handleRemark.includes("上级退回")) {
                if (item.nodeText === "售后审核" || item.nodeText === "售后复审" || item.nodeText === "售后确认") {
                  this.handleDetailVos.push(item);
                }
              }
            }
          });
      },
      bindQRCode(row) {
        console.log(row.pkid);
      },
      printCurrent(row) {
        document.body.innerHTML = document.getElementById("content").innerHTML;
        window.print();
        window.location.reload();
        return false;
      },
      print() {
        // this.htmlTitle = this.model.billNo;
        // htmlToPdf.getPdf("#content", this.htmlTitle);
        let title = this.model.billNo;
        html2Canvas(document.querySelector("#content"), {
          allowTaint: true,
        }).then(function(canvas) {
          let contentWidth = canvas.width;
          let contentHeight = canvas.height;
          let pageHeight = (contentWidth / 592.28) * 841.89;
          let leftHeight = contentHeight;
          let position = 0;
          let imgWidth = 595.28;
          let imgHeight = (592.28 / contentWidth) * contentHeight;
          let pageData = canvas.toDataURL("image/jpeg", 1.0);
          let PDF = new JsPDF("", "pt", "a4");
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
              leftHeight -= pageHeight;
              position -= 841.89;
              if (leftHeight > 0) {
                PDF.addPage();
              }
            }
          }
          PDF.save(title + ".pdf");
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.qrCode {
  .qrCode-div {
    page-break-after: always;

    .table {
      tr {
        td {
          font-size: 12px;
          padding: 10px;
        }
      }
    }
  }
}
</style>
